import { Injectable, isDevMode } from '@angular/core';

const KEY = 'authCooperativeToken';

@Injectable({ providedIn: 'root' })
export class TokenCooperativeService {
  storage = isDevMode() ? window.localStorage : window.sessionStorage;

  hasToken() {
    return !!this.getToken();
  }

  setToken(token: string) {
    this.storage.setItem(KEY, token);
  }

  getToken() {
    return this.storage.getItem(KEY);
  }

  removeToken() {
    this.storage.removeItem(KEY);
  }
}
